import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { UserService } from 'src/app/modules/account/shared/user.service';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { CountService } from '../../services/count.service';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';

@Component({
  selector: 'app-betting-slip-modal',
  templateUrl: './betting-slip-modal.component.html',
  styleUrls: ['./betting-slip-modal.component.scss'],
  providers: [MessageService]
})

export class BettingSlipModalComponent implements OnInit {
  raceDetail: any;
  betSlip: any;
  coupon: any;
  winners: any;
  allData;
  loading = true;
  loadCancel = false;
  results: any;
  finalResults: any;
  loadingModal = true;
  timeToStart;
  count: number = 0;
  browserName;
  constructor(
    private router: Router,
    private datePipe: DatePipe,
    public ref: DynamicDialogRef,
    private userService: UserService,
    public config: DynamicDialogConfig,
    private messageService: MessageService,
    private translateService: TranslateService,
    private localStoreService: LocalStoreService,
    public authService: AuthService,
    private countService: CountService
  ) { }

  ngOnInit() {
    this.openBetSlip();

    this.getBrowserName();


  }



  openBetSlip() {
    this.loadingModal = true;
    this.userService.getCouponDetailById({ couponId: this.config.data.couponId }).subscribe((res) => {
      let couponDetailData;
      if (res.success) {
        couponDetailData = res.success.data;
        let userCoupons = this.localStoreService.getItem(this.config.data.raceId);
        const prop = this.config.data.couponId;
        if (userCoupons && userCoupons[prop]) {
          delete userCoupons[prop];
          this.localStoreService.setItem(this.config.data.raceId, userCoupons);
        }
      } else {
        couponDetailData = this.checkUserBetSlip(this.config.data.couponId, this.config.data.raceId);
      }

      if (couponDetailData) {
        couponDetailData.betSlip.bets.sort(function (a, b) {
          let keyA = a.runnerOrder,
            keyB = b.runnerOrder;
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });

        this.coupon = couponDetailData.coupon;
        this.betSlip = couponDetailData.betSlip;
        this.raceDetail = couponDetailData.raceDetail;
        this.winners = couponDetailData.Winners;
        this.results = couponDetailData.Odds;
        (this.results && Object.keys(this.results).length > 0) && this.resultsFormat();
        this.allData = couponDetailData;
        this.isRaceStarted();
        this.loadingModal = false;
      } else {
        this.ref.close({ message: this.translateService.instant('ALERT.SOMETHING_WENT_WRONG') })
      }
    });
  }

  isRaceStarted() {
    const status = this.allData?.coupon?.status;
    if (status === 'open' || status === 'started' || status === 'temporary') {
      const localDate = new Date(this.allData?.betSlip?.raceScheduleTimeUtc);
      localDate.setHours(localDate.getHours() - (new Date().getTimezoneOffset() / 60));
      const difference = localDate.getTime() - new Date().getTime();
      this.timeToStart = Math.round(difference / 1000);
    }
  }


  goToRace() {
    this.loadingModal = true;
    let raceSlug = '/race/' + this.raceDetail.Country + '/' + this.datePipe.transform(this.betSlip.raceScheduleTimeUtc.replace(/ /g, "T"), 'dd-MM-Y');
    raceSlug += '/' + this.raceDetail.Track + '/' + this.betSlip.raceId;

    this.config?.data?.hidePrint ?
      this.router.navigateByUrl('/races/all', { skipLocationChange: true }).then(() => this.router.navigate([raceSlug])) :
      this.router.navigateByUrl(raceSlug);
    if (this.getPrettyName(this.router.url) !== raceSlug) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.loadingModal = false;
          this.ref.close();
        }
      });
    } else {
      this.ref.close();
    }
  }

  getPrettyName(param: string): string {
    param = param.replace(/ /g, '-');
    if (param.includes('%20')) {
      param = param.includes('%20') ? param.replace(/%20/g, ' ') : param.replace(/%/g, ' ')
    }
    if (param.includes('%C2%B4')) {
      param.replace(/%C2%B4/g, ' ')
    }
    return param;
  }

  resultsFormat() {
    const deuxTypeResult = this.results.filter(x => x.type === 'pmu_deux_sur_quatre');
    const deuxTypePlacesArr = [];
    deuxTypeResult.forEach(res => {
      res.places.forEach(resPlace => {
        deuxTypePlacesArr.push(resPlace);
      });
    });
    const uniqueItems = [...new Set(deuxTypePlacesArr)];
    const deuxTypeRes = this.results.find((x) => x.type === 'pmu_deux_sur_quatre');

    if (deuxTypeRes) {
      deuxTypeRes.places = uniqueItems;
      deuxTypeRes.type = 'edited_pmu_deux_sur_quatre';
    }

    this.finalResults = this.results.filter(x => x.type !== 'pmu_deux_sur_quatre');
  }

  print() {
    this.messageService.clear();

    this.getBrowserName();


    this.countService.count++;
    if (this.browserName === 'safari' && this.countService.count != 1) {
      alert(this.translateService.instant('ALERT.Please_refresh_the_page_to_print'))
    } else {
      setTimeout(() => {
        window.scrollTo({ top: 0 });
        try {

          document.execCommand('print', false, null)
        } catch {
          window.print()
        }
      }, 1000);
    }



    /* var prtContent = document.getElementById('content');
     var WinPrint = window.open('', '', 'width=800,height=650,scrollbars=1,menuBar=1');
     var str =  prtContent.innerHTML;
     WinPrint.document.write(str);
     WinPrint.document.close();
     WinPrint.focus();*/


  }

  checkUserBetSlip(couponId, raceId) {
    let userCoupons = this.localStoreService.getItem(raceId);
    const userCouponData = userCoupons && userCoupons[couponId];
    return userCouponData;
  }

  cancelCoupon() {
    this.loadCancel = true;
    const betSlipId = this.coupon.betSlipId;
    this.userService.cancelCouponById({ betSlipId })
      .pipe(finalize(() => { this.loadCancel = false })).subscribe(data => {
        data.success ?
          this.ref.close({ betSlipId, message: data.success.message, messageCode: data.success.messageCode }) :
          this.ref.close({ message: data?.error?.message, messageCode: data?.error?.messageCode })
      });
  }

  printVisible() {
    return !this.config?.data?.hidePrint;
  }


  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return this.browserName = 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return this.browserName = 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return this.browserName = 'chrome';


      case agent.indexOf('trident') > -1:
        return this.browserName = 'ie';
      case agent.indexOf('firefox') > -1:
        return this.browserName = 'firefox';
      case agent.indexOf('safari') > -1:
        return this.browserName = 'safari';

      default:
        return this.browserName = 'other';
    }
  }
}
